// please keep in alphabetical order for ease of reading
export default {
    'addins-launchAddinsFromUrl': {},
    'an-client-event': {},
    'an-sampled-client-event': {},
    'an-client-error': {},
    'an-client-verbose-wl': {},
    'an-client-network-request': {},
    'auth-domainConnect': {},
    'auth-domainConnectDemandGen': {},
    'auth-cutOverSoftLanding': {
        description: 'Allows the React Mail cut over FRE to be shown',
    },
    'auth-leftNavPremiumUpsell': {},
    'auth-leftNavPremiumUpsellAdvancedProtection': {},
    'auth-leftNavPremiumUpsellGoPremium': {},
    'auth-leftNavPremiumUpsellOneTB': {},
    'auth-leftNavPremiumUpsellNoAds': {},
    'auth-leftNavPremiumUpsellNoCCControl': {},
    'auth-leftNavPremiumUpsellNoCCTreatment': {},
    'auth-leftNavInAppUpsell': {},
    'auth-openAnotherMailbox': {
        description: 'Enables the "Open another mailbox" dialog menu item for explicit login',
    },
    'auth-ServiceWorkerEdge': {},
    'auth-ServiceWorkerSafari': {},
    'cal-agendaMail-feedback': {},
    'cal-ics-preview': {},
    'cal-interestingCalendar': {},
    'cal-stickyNotesFolder': {},
    'cmp-accChecker': {},
    'cmp-delaySend': {
        description: 'Enables the Delay/Undo send feature',
    },
    'cmp-tabDragOverArrow': {
        description: 'When dragging something to switch tabs, show a small arrow above the tab to hint at the timeout',
    },
    'cmp-editorPerfMeasure': {
        description: 'Measure the perf of editor in compose',
    },
    'cmp-encryption': {},
    'cmp-mailtips': {},
    'cmp-mentions': {},
    'cmp-newEmoji-plugin': {
        description: 'Refactored and rewritten emoji picker and corpus, sourced from roosterJS',
    },
    'cmp-newMentionPlugin': {
        description: 'Enables the use of the newly refactored mentions plugin, sourced from roosterjs',
    },
    'cmp-pasteOption': {},
    'cmp-quickSwitcher': {
        description: 'Toolbar for moving quickly between areas of the app and running commands',
    },
    'cmp-stickyDocking': {},
    'cmp-throwOnLostFocus': {
        description: 'Throws when focus is given to the document body or set to null.' +
            ' For debugging acessibility. DO NOT enable in prod.',
    },
    'cmp-upgradeCompose': {
        description: 'Loads the editor before retrieving the quoted body in compose',
    },
    'cmp-manageIRM': {
        description: 'Enabled the UI to manage the IRM template applied to a message',
    },
    'cmp-policyTips': {
        description: 'Enables the fetching of, managing of, and displaying of policyTips for enterprise.',
    },
    'fwk-ads': {},
    'fwk-ads-programmatic-br': {},
    'fwk-ads-programmatic-none': {},
    'fwk-ads-removeUpsell': {},
    'fwk-ads-upgradeUpsell': {},
    'fwk-ads-disableFallback': {},
    'fwk-nativeAds-bingOneClickCallMediation': {},
    'fwk-nativeads-bingBackfill': {},
    'fwk-nativeads-killFanRefresh': {},
    'fwk-nativeads-disableIcons': {},
    'fwk-perf-fps': {},
    'fwk-webNotification': {},
    'help-miniMavenWidget': {},
    'chat-o365shellheader': {},
    'mc-botConversation': {},
    'mc-confetti': {},
    'mc-cortanaCompose': {},
    'mc-expPicker': {},
    'mc-imageDiagnostics': {},
    'mc-imageSxS': {},
    'mc-replyWith': {},
    'mc-replyWithMRU': {},
    'mc-replyWithProps': {},
    'mc-smartPills': {},
    'mc-smartReply': {},
    'mc-smartSuggestions': {},
    'mc-userHighlighting': {},
    'peo-subjectPicker': {},
    'pf-picker': {},
    'pf-post': {},
    'rp-actionableMessages': {},
    'rp-actionableMessages-contextual': {},
    'rp-actionableMessages-msa-token': {},
    'rp-actionableMessages-aad-token': {},
    'rp-actionableMessages-lpc': {},
    'rp-opay-modelb-endpoint': {},
    'rp-acTUIBubble': {
        description: 'Adds Teaching Bubble teaching UI to Actionable Message RP',
    },
    'rp-adaptiveCardsRecordLinks': {
        description: 'Enables the logging of links on AdaptiveCards',
    },
    'rp-acDisableTransactionCard': {
        description: 'Disables the transaction card',
    },
    'rp-infoBarBrandSubscription': {
        description: 'Enable Unsubscribe from Infobar',
    },
    'rp-addins': {},
    'rp-brandDecorations': {},
    'rp-calendarRollup': {},
    'rp-cardUI': {},
    'rp-collapsedItemsRollUp': {},
    'rp-expCollAllButton': {},
    'rp-outlookAddinsDeeplink': {},
    'rp-immersiveReader': {},
    'rp-immersiveReaderDogfood': {},
    'rp-immersiveReaderV2Endpoint': {},
    'rp-isSentOnBehalfOf': {},
    'rp-like': {
        description: 'Option to Like/Unlike a message from the reading pane',
    },
    'rp-oofRollup': {},
    'rp-popouts': {},
    'rp-csaExp': {},
    'rp-csaExpWithMenuIcons': {},
    'rp-safetyMessage': {},
    'rp-selectionUI': {},
    'rp-tabView': {},
    'rp-wideContent': {},
    'rp-smartTime': {},
    'rp-replyImageProxy': {},
    'sea-categoryClientSuggestions': {
        description: 'Shows category suggestions on search typedown',
    },
    'sea-centered': {
        description: 'Makes the search box a fixed width and centered in the header.',
    },
    'sea-circlePersonas': {},
    'sea-commonSearchBox': {
        description: 'Uses common search box from client-controls',
    },
    'sea-contextFeedback': {},
    'sea-debugHook': {},
    'sea-qFDebounceOff': {
        description: 'Remove debounce delay before issuing search suggestion requests',
    },
    'sea-fileCommands': {
        description: 'Show file commands in command mode',
    },
    'sea-filesSuggestions': {
        description: 'Shows files suggestions on search typedown',
    },
    'sea-floodgateSurvey': {
        description: 'Floodgate survey for search scenarios',
    },
    'sea-galSuggestions': {
        description: 'Shows people suggestions on search when 3S fails to send any suggestions',
    },
    'sea-sendPillQueryText': {
        description: 'Prepends pills (using their QueryText) to the query text sent in suggestions calls. Overridden by sea-sendPillDisplayText.',
    },
    'sea-sendPillDisplayText': {
        description: 'Prepends pills (using their DisplayText) to the query text sent in suggestions calls. Overrides sea-sendPillQueryText.',
    },
    'sea-warmupQueries': {
        description: 'Makes 3S Query calls as the user types in the searchbox',
    },
    'sea-emailSuggestions': {
        description: 'Shows email message suggestions on search typedown',
    },
    'sea-emailSuggestionsInTab': {
        description: 'open email message suggestions in a new tab',
    },
    'sea-pin': {},
    'sea-proxy3SQuery': {
        description: "When enabled, we will directly call the 3S query endpoint via OWS' proxy instead of OWS' API (i.e. ExecuteSearch transformations will be done on the client).",
    },
    'sea-qf': {},
    'sea-resultInstrumentation': {},
    'sea-spellingCorrectedSearch': {
        description: 'Shows suggestions for misspelled search queries.',
    },
    'sea-substrateQuery': {},
    'tri-bulkActionNotification': {},
    'tri-disableDynamicFolderPane': {
        description: 'Disables dynamic folder pane expansion / collapse',
    },
    'tri-favoriteSearch': {},
    'tri-focused-pivot': {
        description: 'Show F/O as pivots instead of pills',
    },
    'tri-focused-sticky-rollup': {
        description: 'Show Other rollup outside of the scroll region',
    },
    'tri-folderPermissions': {
        description: 'Add folder permissions feature',
    },
    'tri-inbox-focused-other-pivot': {
        description: 'Show All, Focused, Other pivots in F/O header',
    },
    'tri-inbox-focused-pivot': {
        description: 'Show All, Focused pivots in F/O header',
    },
    'tri-ignore': {
        description: 'Ignore conversation feature',
    },
    'tri-messageAttachmentPreviews': {
        description: 'Shows attachment previews in the message view',
    },
    'tri-moveToSweepOption': {
        description: 'Allows user to initiate sweep from moveTo menu',
    },
    'tri-smartMergeFindResponse': {
        description: 'Merges the FindConv/FindItem with the cached response data only if the lastModifiedTime changed',
    },
    'tri-nonSubstrateInference': {},
    'tri-notificationBar': {},
    'tri-retentionPolicies': {
        description: 'Adds triage action of assigning policy for folders, mail items',
    },
    'tri-runRulesNow': {
        description: 'Adds option to run rule now from rule creation and rules option',
    },
    'tri-selectionRefactor': {
        description: 'Updating selection behavior to be more accurate and performant when doing keyboard selection',
    },
    'tri-sharedFolders': {
        description: 'Add shared folders feature',
    },
    'tri-snooze': {
        description: 'Adds snooze feature to delay message delivery.',
    },
    'tri-superConversationExpansion': {
        description: 'Adds additional functionality to expanded conversations',
    },
    'tri-superJunkSettings': {
        description: 'Adds additional functionality to the junk options page and notifications',
    },
    'tri-sweepBulkAction': {
        description: 'Controls whether bulk actions payloads will be sent from the server for sweep',
    },
    'tri-turnOffFocusedOther': {
        description: 'Adds a dialog in the mail list header to prompt user to turn off FO',
    },
    'tri-upNext': {},
    'usv-forum': {},
    'getStarted-tasksGroupA': {},
    'getStarted-tasksGroupB': {},
    grp: {},
    'help-proactiveMessaging': {},
    'gsx-translator-translateMessage': {},
    'help-o365ShellHeader-MaxPane': {},
};
//# sourceMappingURL=mailFeatures.js.map